(function () {
  'use strict';
  if (window.__gbar15guInit) return;
  window.__gbar15guInit = true;

  var instances = [];
  var pendingForm = null;
  var OFFER = 'ar15-gifts-unlock-20260829';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function number(v, fallback) {
    var n = Number(v);
    return isFinite(n) ? n : (fallback || 0);
  }
  function currencyFormatter(currency) {
    var code = String(currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '').toUpperCase();
    try {
      var nf = new Intl.NumberFormat('en-US', { style: 'currency', currency: code, minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return function (cents) { return nf.format(number(cents) / 100); };
    } catch (e) {
      return function (cents) { return (number(cents) / 100).toFixed(2); };
    }
  }

  function instanceFor(form) {
    pruneInstances();
    for (var i = instances.length - 1; i >= 0; i -= 1) {
      var inst = instances[i];
      if (inst.root.isConnected && inst.form() === form) return inst;
    }
    return null;
  }
  function isAr15Form(form) {
    if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return false;
    var roots = [].slice.call(document.querySelectorAll('[data-gbar15gu]'));
    return roots.some(function (root) {
      var data = root.querySelector('script[data-gbar15gu-data]');
      if (!data) return false;
      try {
        var cfg = JSON.parse(data.textContent || '{}');
        return document.getElementById('product-form-' + cfg.sectionId) === form;
      } catch (e) { return false; }
    });
  }

  /* Capture before theme product-form listeners; this widget always owns its Kar98 submit. */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
    var inst = instanceFor(form);
    if (!inst && !window.__gbar15guReady && isAr15Form(form)) {
      event.preventDefault(); event.stopImmediatePropagation(); pendingForm = form; return;
    }
    if (!inst) return;
    inst.submit(form, event);
  }, true);

  function initRoot(root) {
    if (!root || root.__gbk98guBound) return;
    var dataEl = root.querySelector('script[data-gbar15gu-data]');
    if (!dataEl) return;
    var cfg;
    try { cfg = JSON.parse(dataEl.textContent || '{}'); } catch (e) { return; }
    var products = cfg.products || [];
    if (!products.length) return;
    root.__gbk98guBound = true;
    var byId = {};
    products.forEach(function (p) { byId[String(p.id)] = p; });
    var host = byId[String(cfg.hostId)] || products[0];
    var formScope = root.closest('.product__info-container, .main-product__info-container, .shopify-section') || document;
    var state = { tier: 2, slots: [String(host.id), String(host.id), String(host.id)], activeSlot: '1', filter: 'all', sort: 'none', pickerOpen: false, focusBeforeOpen: null, scrollLock: null };
    var formatMoney = currencyFormatter(cfg.currency);
    var gifts = cfg.gifts || { mystery1: { id: 45916525428915, value: 4999 }, mystery2: { id: 45916525461683, value: 4999 } };
    var membership = cfg.membership || { variantId: 45597242949811, sellingPlan: 5880185011 };
    /* Live native multi-unit discount groups (portfolio + Sandstorm nodes). Those
       nodes also fire on offer-tagged lines, so displayed totals must include them
       per product; Club 5% applies only to lines no node discounts (verified
       against real checkout totals 2026-08-28). */
    var dgroups = cfg.dgroups || [];
    var offer = cfg.offer || OFFER;

    function form() {
      var idForm = document.getElementById('product-form-' + cfg.sectionId);
      if (idForm && (formScope === document || formScope.contains(idForm))) return idForm;
      return formScope.querySelector('form[data-type="add-to-cart-form"]');
    }
    function hostVariantId() {
      var f = form();
      var input = f && f.querySelector('[name="id"]');
      return number(input && input.value, number(cfg.hostVariantId, number(host.v)));
    }
    function productForSlot(index) { return byId[String(state.slots[index])] || host; }
    function variantFor(product, isHost) {
      return { id: isHost ? hostVariantId() : number(product.v), price: number(product.p), compare: number(product.cp, number(product.p)), product: product };
    }
    function clubChecked() {
      var box = (formScope.querySelector && formScope.querySelector('[data-gb-membership] .gb-check')) || document.querySelector('[data-gb-membership] .gb-check');
      return !!(box && box.checked);
    }
    function groupIndexFor(productId) {
      var pid = number(productId);
      for (var i = 0; i < dgroups.length; i += 1) {
        var ids = dgroups[i] && dgroups[i].ids || [];
        for (var j = 0; j < ids.length; j += 1) if (number(ids[j]) === pid) return i;
      }
      return -1;
    }
    function paidForTier(tier) {
      var paid = [variantFor(host, true)];
      for (var i = 1; i < tier; i += 1) paid.push(variantFor(productForSlot(i), false));
      return paid;
    }
    function tierTotals(tier) {
      /* Display models carry no multi-unit discount nodes and are not in the
         Blaster Club product-discount allowlist, so tier prices are the plain
         sum of the paid lines — checkout-true by construction. */
      var paid = paidForTier(tier), price = 0, compare = 0;
      paid.forEach(function (line) {
        price += line.price;
        compare += line.compare;
      });
      if (tier >= 2) compare += number(gifts.mystery1.value, 4999);
      if (tier >= 3) compare += number(gifts.mystery2.value, 4999);
      return { price: price, compare: compare, save: Math.max(0, compare - price) };
    }
    function initMix(el) {
      var extras = number(el.getAttribute('data-extras'));
      var lines = document.createElement('div'); lines.className = 'gbk98gu__mix-lines';
      var rows = [];
      for (var i = 0; i <= extras; i += 1) {
        var row = document.createElement('div'); row.className = 'gbk98gu__mix-row' + (i ? ' gbk98gu__mix-row--extra' : ''); row.setAttribute('data-slot', String(i));
        var img = document.createElement('img'); img.width = 60; img.height = 60; img.alt = '';
        var copy = document.createElement('div'); var name = document.createElement('b'); var hint = document.createElement('span'); copy.appendChild(name); copy.appendChild(hint); row.appendChild(img); row.appendChild(copy);
        if (i) { var change = document.createElement('button'); change.className = 'gbk98gu__change'; change.type = 'button'; change.setAttribute('data-slot', String(i)); change.setAttribute('aria-label', 'Change model in slot ' + String(i)); change.innerHTML = '<span aria-hidden="true">⇄ CHANGE</span><small>MODEL</small>'; row.appendChild(change); }
        rows.push({ el: row, img: img, name: name, hint: hint }); lines.appendChild(row);
      }
      el.innerHTML = ''; el.appendChild(lines); el.__gbk98guMix = { extras: extras, rows: rows };
    }
    function syncMix() {
      root.querySelectorAll('[data-gbar15gu-mix]').forEach(function (el) {
        if (!el.__gbk98guMix) initMix(el);
        var mix = el.__gbk98guMix;
        mix.rows.forEach(function (row, index) {
          var item = index ? productForSlot(index) : host;
          row.img.src = item.img || ''; row.name.textContent = item.t || ''; row.hint.textContent = index ? (index === 1 ? '2nd model' : '3rd model') : 'This item';
        });
      });
    }
    function setGift(key, on, name) {
      var el = root.querySelector('[data-gbar15gu-gift="' + key + '"]'); if (!el) return;
      el.classList.toggle('is-locked', !on); el.setAttribute('aria-label', on ? name : 'Locked');
      var p = el.querySelector('p'); if (p) p.textContent = on ? name : 'Locked';
    }
    function renderPrices() {
      root.querySelectorAll('[data-gbar15gu-tier]').forEach(function (card) {
        var tier = number(card.getAttribute('data-gbar15gu-tier')); var totals = tierTotals(tier);
        var price = card.querySelector('[data-gbar15gu-price]'); var compare = card.querySelector('[data-gbar15gu-compare]'); var save = card.querySelector('[data-gbar15gu-save]');
        if (price) price.textContent = formatMoney(totals.price);
        if (compare) compare.textContent = formatMoney(totals.compare);
        if (save) save.textContent = 'Save ' + formatMoney(totals.save);
      });
    }
    function renderTierSelection() {
      root.querySelectorAll('[data-gbar15gu-tier]').forEach(function (card) {
        var on = number(card.getAttribute('data-gbar15gu-tier')) === state.tier; card.classList.toggle('is-on', on); card.setAttribute('aria-checked', on ? 'true' : 'false'); card.setAttribute('aria-expanded', on ? 'true' : 'false'); card.tabIndex = on ? 0 : -1;
      });
      setGift('mystery1', state.tier >= 2, 'FREE Mystery Model'); setGift('mystery2', state.tier >= 3, 'FREE 2nd Mystery Model');
    }
    function renderDynamic() {
      renderPrices(); syncMix();
    }
    function selectTier(nextTier) {
      nextTier = number(nextTier, 0);
      if (nextTier < 1 || nextTier > 3 || nextTier === state.tier) return false;
      state.tier = nextTier;
      renderTierSelection();
      return true;
    }
    function renderState() {
      renderTierSelection();
      renderDynamic();
    }
    function productTypes() {
      var seen = {}, types = []; products.forEach(function (p) { var type = String(p.ty || '').trim(), key = type.toLowerCase(); if (type && !seen[key]) { seen[key] = true; types.push(type); } }); return types;
    }
    function filteredProducts() {
      var list = products.slice();
      if (state.filter !== 'all') list = list.filter(function (p) { return String(p.ty || '').toLowerCase() === state.filter.toLowerCase(); });
      if (state.sort === 'low') list.sort(function (a, b) { return number(a.p) - number(b.p); });
      if (state.sort === 'high') list.sort(function (a, b) { return number(b.p) - number(a.p); });
      return list;
    }
    var modalTitleId = 'gbar15guModalTitle-' + String(cfg.sectionId || instances.length).replace(/[^a-zA-Z0-9_-]/g, '-');
    var overlay = document.createElement('div'); overlay.className = 'gbk98gu-overlay'; overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML = '<div class="gbk98gu-modal" role="dialog" aria-modal="true" aria-labelledby="' + esc(modalTitleId) + '" tabindex="-1"><div class="gbk98gu-modal__top"><div class="gbk98gu-modal__title" id="' + esc(modalTitleId) + '"></div><button class="gbk98gu-x" type="button" data-gbar15gu-close aria-label="Close">×</button></div><div class="gbk98gu-filters" data-gbar15gu-filters></div><div class="gbk98gu-picker" data-gbar15gu-picker></div></div>';
    document.body.appendChild(overlay);
    var modal = overlay.querySelector('.gbk98gu-modal'), modalTitle = overlay.querySelector('.gbk98gu-modal__title'), filters = overlay.querySelector('[data-gbar15gu-filters]'), picker = overlay.querySelector('[data-gbar15gu-picker]');
    function renderFilters() {
      var label = state.sort === 'low' ? '↑ Price: Low' : state.sort === 'high' ? '↓ Price: High' : '⇅ Price';
      filters.innerHTML = '<button type="button" class="gbk98gu-filter gbk98gu-filter--sort' + (state.sort !== 'none' ? ' is-on' : '') + '" data-sortcycle>' + esc(label) + '</button><button type="button" class="gbk98gu-filter' + (state.filter === 'all' ? ' is-on' : '') + '" data-filter="all">All</button>' + productTypes().map(function (t) { return '<button type="button" class="gbk98gu-filter' + (state.filter.toLowerCase() === t.toLowerCase() ? ' is-on' : '') + '" data-filter="' + esc(t) + '">' + esc(t) + '</button>'; }).join('');
    }
    function renderPicker() {
      var list = filteredProducts();
      picker.innerHTML = list.length ? list.map(function (item) { var first = String(item.t || 'Model').split(/\s+/)[0]; return '<article class="gbk98gu-item" data-gbar15gu-item data-id="' + esc(item.id) + '"><img class="gbk98gu-item__img" src="' + esc(item.img) + '" alt="" loading="lazy"><div class="gbk98gu-item__info"><span class="gbk98gu-item__name">' + esc(item.t) + (item.bs ? '<span class="gbk98gu-tag">Bestseller</span>' : '') + '</span><span class="gbk98gu-item__prices"><span class="gbk98gu-item__price">' + esc(item.pm || formatMoney(item.p)) + '</span><s class="gbk98gu-item__compare">' + esc(item.cpm || formatMoney(item.cp || item.p)) + '</s></span></div><div class="gbk98gu-item__footer"><button class="gbk98gu-choose" type="button" data-gbar15gu-choose data-id="' + esc(item.id) + '">CHOOSE ' + esc(first.toUpperCase()) + '</button></div></article>'; }).join('') : '<p class="gbk98gu-empty">No models match this filter.</p>';
      picker.scrollTop = 0;
    }
    function focusables() { return [].slice.call(modal.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (el) { return el.offsetWidth || el.offsetHeight || el === document.activeElement; }); }
    function focusTrap(e) {
      if (!state.pickerOpen) return;
      if (e.key === 'Escape' || e.keyCode === 27) { e.preventDefault(); closePicker(); return; }
      if (e.key !== 'Tab' && e.keyCode !== 9) return;
      var nodes = focusables(); if (!nodes.length) { e.preventDefault(); modal.focus(); return; }
      if (e.shiftKey && document.activeElement === nodes[0]) { e.preventDefault(); nodes[nodes.length - 1].focus(); } else if (!e.shiftKey && document.activeElement === nodes[nodes.length - 1]) { e.preventDefault(); nodes[0].focus(); }
    }
    document.addEventListener('keydown', focusTrap, true);
    function lockPage() {
      var doc = document.documentElement, body = document.body, y = window.pageYOffset || doc.scrollTop || body.scrollTop || 0, gap = window.innerWidth - doc.clientWidth;
      state.scrollLock = { y: y, html: { overflow: doc.style.overflow, overscroll: doc.style.overscrollBehavior }, body: { overflow: body.style.overflow, position: body.style.position, top: body.style.top, width: body.style.width, paddingRight: body.style.paddingRight, overscroll: body.style.overscrollBehavior } };
      doc.style.overflow = 'hidden'; doc.style.overscrollBehavior = 'none'; body.style.overflow = 'hidden'; body.style.overscrollBehavior = 'none'; body.style.position = 'fixed'; body.style.top = '-' + y + 'px'; body.style.width = '100%'; if (gap > 0) body.style.paddingRight = gap + 'px';
    }
    function unlockPage() {
      var saved = state.scrollLock; if (!saved) return; state.scrollLock = null; var doc = document.documentElement, body = document.body;
      doc.style.overflow = saved.html.overflow; doc.style.overscrollBehavior = saved.html.overscroll; body.style.overflow = saved.body.overflow; body.style.position = saved.body.position; body.style.top = saved.body.top; body.style.width = saved.body.width; body.style.paddingRight = saved.body.paddingRight; body.style.overscrollBehavior = saved.body.overscroll; window.scrollTo(0, saved.y);
    }
    function openPicker(slot) {
      if (String(slot) !== '1' && String(slot) !== '2') return; state.activeSlot = String(slot); state.focusBeforeOpen = document.activeElement; modalTitle.innerHTML = 'Choose your ' + (state.activeSlot === '1' ? '2nd' : '3rd') + ' model — <b>SAVE 50%</b>'; state.filter = 'all'; state.sort = 'none'; renderFilters(); renderPicker(); state.pickerOpen = true; lockPage(); overlay.classList.add('is-on'); overlay.setAttribute('aria-hidden', 'false'); document.documentElement.classList.add('gbk98gu-modal-open'); window.setTimeout(function () { var close = overlay.querySelector('[data-gbar15gu-close]'); if (close) close.focus(); }, 0);
    }
    function closePicker() {
      if (!state.pickerOpen) return; state.pickerOpen = false; overlay.classList.remove('is-on'); overlay.setAttribute('aria-hidden', 'true'); document.documentElement.classList.remove('gbk98gu-modal-open'); unlockPage(); if (state.focusBeforeOpen && state.focusBeforeOpen.isConnected && state.focusBeforeOpen.focus) state.focusBeforeOpen.focus(); state.focusBeforeOpen = null;
    }
    function showError(message) { var error = root.querySelector('[data-gbar15gu-error]'); if (error) { error.hidden = false; error.textContent = message || 'We could not add this bundle. Please try again.'; } }
    function clearError() { var error = root.querySelector('[data-gbar15gu-error]'); if (error) { error.hidden = true; error.textContent = ''; } }
    function setButtonState(f, busy) { var button = f && f.querySelector('button[name="add"], button[type="submit"], [type="submit"]'); if (!button) return; if (busy) { button.__gbk98WasDisabled = button.disabled; button.disabled = true; button.classList.add('loading'); button.setAttribute('aria-busy', 'true'); } else { button.disabled = !!button.__gbk98WasDisabled; button.classList.remove('loading'); button.removeAttribute('aria-busy'); delete button.__gbk98WasDisabled; } }
    function lineProperties(role, bundle, slot) { var p = { _gbk98_bundle: bundle, _gbk98_offer: offer, _gbk98_role: role, _gbk98_no_tier: 'true' }; if (slot) p._gbk98_slot = String(slot); return p; }
    function buildCartItems(tier, bundle) {
      var items = [];
      paidForTier(tier).forEach(function (line, index) { items.push({ id: number(line.id), quantity: 1, properties: lineProperties('paid', bundle, index + 1) }); });
      function pushGift(gift, minPaid) { items.push({ id: number(gift.id), quantity: 1, properties: { _gbk98_bundle: bundle, _gbk98_offer: offer, _gbk98_role: 'gift', _gift: 'true', _locked: 'true', _gbk98_min_paid: String(minPaid) } }); }
      if (tier >= 2) pushGift(gifts.mystery1, 2);
      if (tier >= 3) pushGift(gifts.mystery2, 3);
      return items;
    }
    function membershipPresent(cart) { return (cart && cart.items || []).some(function (item) { return number(item.variant_id || item.id) === number(membership.variantId); }); }
    function dispatchCartEvents(data) { ['cart:refresh', 'cart:build', 'cart:updated', 'cart:added'].forEach(function (name) { try { document.dispatchEvent(new CustomEvent(name, { detail: { data: data, source: 'gbk98gu' } })); } catch (e) {} }); }
    function decorateGiftLines(scope) {
      var base = scope && scope.querySelectorAll ? scope : document;
      var selector = '.cart-item--product-free-mystery-display-model-ar15-bundle-gift, .cart-item--product-free-2nd-mystery-display-model-ar15-bundle-gift';
      base.querySelectorAll(selector).forEach(function (row) {
        var title = row.querySelector('.cart-item__name');
        if (title && !row.querySelector('.gbk98-cart-gift-badge')) {
          var badge = document.createElement('span'); badge.className = 'gbk98-cart-gift-badge'; badge.setAttribute('role', 'status'); badge.setAttribute('aria-label', 'Free gift included with bundle'); badge.textContent = 'FREE GIFT'; title.insertAdjacentElement('afterend', badge);
        }
        row.querySelectorAll('cart-remove-button, quantity-input').forEach(function (control) { control.hidden = true; control.style.display = 'none'; });
        var quantity = row.querySelector('.cart-item__quantity-wrapper');
        if (quantity && !quantity.querySelector('.gbk98-cart-included')) { var included = document.createElement('span'); included.className = 'gbk98-cart-included'; included.setAttribute('role', 'status'); included.textContent = 'Included with bundle'; quantity.appendChild(included); }
        row.querySelectorAll('.cart-item__final-price, .cart-item__totals .price--end, .cart-item__price-wrapper .price--end').forEach(function (price) { if (price.textContent !== 'FREE') price.textContent = 'FREE'; price.classList.add('gbk98-cart-gift-price'); price.setAttribute('aria-label', 'Free'); });
      });
    }
    function observeGiftDrawer() {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || drawer.__gbk98GiftObserver) return;
      drawer.__gbk98GiftObserver = new MutationObserver(function () { decorateGiftLines(drawer); });
      drawer.__gbk98GiftObserver.observe(drawer, { childList: true, subtree: true });
      decorateGiftLines(drawer);
    }
    function applySections(data) {
      var html = data && data.sections && data.sections['cart-drawer'];
      if (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        /* Swap the .drawer__inner contents (header count + items + footer totals all
           re-rendered with the new cart) exactly like the native theme add flow; the
           overlay and the cart-drawer root with its listeners stay untouched. Fall
           back to the items-only swap when either inner node is missing. */
        var innerSource = doc.querySelector('.drawer__inner');
        var innerTarget = document.querySelector('cart-drawer .drawer__inner');
        if (innerSource && innerTarget) innerTarget.innerHTML = innerSource.innerHTML;
        else { var from = doc.querySelector('cart-drawer-items'); var to = document.querySelector('cart-drawer-items'); if (from && to) to.replaceWith(from); }
      }
      var iconHtml = data && data.sections && data.sections['cart-icon-bubble'];
      /* Rendered cart-icon-bubble sections carry no #cart-icon-bubble wrapper (that div lives in the header), so fall back to the .shopify-section wrapper. */
      if (iconHtml) { var iconDoc = new DOMParser().parseFromString(iconHtml, 'text/html'), icon = iconDoc.querySelector('#cart-icon-bubble') || iconDoc.querySelector('.shopify-section'), target = document.querySelector('#cart-icon-bubble'); if (icon && target) target.innerHTML = icon.innerHTML; }
      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        /* A bundle add always leaves items in the cart. A stale is-empty on the root
           collapses header/body/footer to height 0 (Shrine CSS) = white panel on the
           first add from an empty cart, so clear it before opening. */
        if (drawer.classList) drawer.classList.remove('is-empty');
        var drawerInner = drawer.querySelector && drawer.querySelector('.drawer__inner');
        if (drawerInner && drawerInner.classList) drawerInner.classList.remove('is-empty');
        if (typeof drawer.open === 'function') drawer.open(); else { drawer.classList.add('active', 'animate'); drawer.setAttribute('open', ''); }
      }
      decorateGiftLines(drawer || document);
    }
    function submit(f, event) {
      if (f.__gbk98Busy) { event.preventDefault(); event.stopImmediatePropagation(); return; }
      event.preventDefault(); event.stopImmediatePropagation(); f.__gbk98Busy = true; clearError(); setButtonState(f, true);
      var tier = state.tier, bundle = 'gbk98-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10), payload = { items: buildCartItems(tier, bundle), sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname };
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (response) { if (!response.ok) throw new Error('cart-read-' + response.status); return response.json(); }).then(function (cart) {
        if (clubChecked() && !membershipPresent(cart)) payload.items.push({ id: number(membership.variantId), quantity: 1, selling_plan: number(membership.sellingPlan), properties: { _gbk98_bundle: bundle, _gbk98_offer: offer, _gbk98_role: 'membership', _source: 'gb_membership_under_atc' } });
        return fetch('/cart/add.js?kaching_bundles=true', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
      }).then(function (response) { if (!response.ok) throw new Error('cart-add-' + response.status); return response.json(); }).then(function (data) { applySections(data); dispatchCartEvents(data); }).catch(function () { showError('We could not add this bundle. Please try again.'); }).then(function () { f.__gbk98Busy = false; setButtonState(f, false); });
    }
    root.querySelectorAll('[data-gbar15gu-mix]').forEach(initMix);
    root.addEventListener('click', function (event) {
      var change = event.target.closest('.gbk98gu__change'); if (change && root.contains(change)) { event.preventDefault(); event.stopPropagation(); openPicker(change.getAttribute('data-slot')); return; }
      if (event.target.closest('button, a, input, select, textarea')) return;
      var card = event.target.closest('[data-gbar15gu-tier]'); if (card && root.contains(card)) selectTier(card.getAttribute('data-gbar15gu-tier'));
    });
    root.addEventListener('keydown', function (event) { var card = event.target.closest('[data-gbar15gu-tier]'); if (!card || event.target !== card) return; if (event.key === 'Enter' || event.key === ' ' || event.keyCode === 13 || event.keyCode === 32) { event.preventDefault(); selectTier(card.getAttribute('data-gbar15gu-tier')); } if (/Arrow(Down|Right|Up|Left)/.test(event.key)) { event.preventDefault(); var cards = [].slice.call(root.querySelectorAll('[data-gbar15gu-tier]')), index = cards.indexOf(card), dir = event.key === 'ArrowDown' || event.key === 'ArrowRight' ? 1 : -1, next = cards[(index + dir + cards.length) % cards.length]; if (next) { next.focus(); selectTier(next.getAttribute('data-gbar15gu-tier')); } } });
    filters.addEventListener('click', function (event) { var sort = event.target.closest('[data-sortcycle]'); if (sort) { state.sort = state.sort === 'none' ? 'low' : state.sort === 'low' ? 'high' : 'none'; renderFilters(); renderPicker(); return; } var filter = event.target.closest('[data-filter]'); if (filter) { var value = String(filter.getAttribute('data-filter') || 'all'); state.filter = state.filter.toLowerCase() === value.toLowerCase() ? 'all' : value; renderFilters(); renderPicker(); } });
    picker.addEventListener('click', function (event) { var choose = event.target.closest('[data-gbar15gu-choose]'); if (!choose) return; var id = String(choose.getAttribute('data-id')); if (!byId[id]) return; state.slots[number(state.activeSlot)] = id; renderDynamic(); closePicker(); });
    overlay.addEventListener('click', function (event) { if (event.target === overlay || event.target.closest('[data-gbar15gu-close]')) closePicker(); });
    function onDocumentChange(event) { if (event.target.matches && event.target.matches('[data-gb-membership] .gb-check')) renderDynamic(); var f = form(); if (f && f.contains(event.target) && event.target.name === 'id') renderState(); }
    function onClubToggle() { renderDynamic(); }
    document.addEventListener('change', onDocumentChange);
    document.addEventListener('gb-club:toggle', onClubToggle);
    function destroy() {
      if (state.pickerOpen) closePicker();
      document.removeEventListener('keydown', focusTrap, true);
      document.removeEventListener('change', onDocumentChange);
      document.removeEventListener('gb-club:toggle', onClubToggle);
      if (overlay && overlay.remove) overlay.remove();
    }
    var instance = { root: root, form: form, submit: submit, overlay: overlay, destroy: destroy }; instances.push(instance); renderState(); observeGiftDrawer();
    if (pendingForm && form() === pendingForm) { var pending = pendingForm; pendingForm = null; var submitEvent = { preventDefault: function () {}, stopImmediatePropagation: function () {} }; submit(pending, submitEvent); }
  }

  function pruneInstances() {
    instances = instances.filter(function (instance) {
      if (instance.root && instance.root.isConnected) return true;
      if (instance.destroy) instance.destroy();
      return false;
    });
  }

  function initAll() {
    pruneInstances();
    [].slice.call(document.querySelectorAll('[data-gbar15gu]')).forEach(initRoot);
  }

  document.addEventListener('gb:quickview:ready', initAll);
  document.addEventListener('shopify:section:load', initAll);

  ready(function () {
    initAll();
    window.__gbar15guReady = true;
    try {
      var scanTimer = null;
      new MutationObserver(function () {
        if (scanTimer) return;
        scanTimer = window.setTimeout(function () { scanTimer = null; initAll(); }, 150);
      }).observe(document.body, { childList: true, subtree: true });
    } catch (error) {}
  });
})();
